module.exports = __webpack_public_path__ + "media/images/emblems/GW-TG-Schlatt-e186be4d20a56a9f25ca807935a245dd.png";